import { connectCaptcha, getUserData, isStaff } from '../../utils'
import MainGuestForm from './MainGuestForm'
import StaffCheckoutForm from './StaffCheckoutForm'
import { createUrl } from '../../localized-urls'
import BookNowPayLater from './BookNowPayLater'
import { Form, FormSpy } from 'react-final-form'
import { FormCheckbox } from '../forms/final-form-fields'
import CheckoutBenefits from './CheckoutBenefits'
import { FormattedMessage } from 'react-intl'
import { scrollToError } from '../../dom-handlers'
import useCurrentShop from '../checkout-la/hooks/useCurrentShop'
import { useEffect, useRef } from 'react'
import { checkoutValidation } from './validation'

const initialValues = getUserData()
export default function CheckoutLastStepForm({
  onCheckoutFormSubmit,
  orderEdit,
  selectedTripData,
  countryCode
}) {
  const { shopInfo } = useCurrentShop()
  const phoneInstance = useRef()

  const getPhoneInstance = (instance) => {
    phoneInstance.current = instance
  }

  useEffect(() => {
    connectCaptcha('captcha', countryCode)
  }, [])

  return (
    <Form
      onSubmit={onCheckoutFormSubmit}
      initialValues={initialValues}
      validate={(values) =>
        checkoutValidation(values, orderEdit, true, phoneInstance.current)
      }
      render={({ handleSubmit, values }) => (
        <form onSubmit={handleSubmit}>
          <FormSpy
            subscription={{ submitFailed: true }}
            onChange={scrollToError}
          />
          {!orderEdit && (
            <MainGuestForm
              getPhoneInstance={getPhoneInstance}
              handleSubmit={handleSubmit}
              shopKind={shopInfo.kind}
              countryCode={countryCode}
            />
          )}
          {isStaff() && <StaffCheckoutForm values={values} />}
          <BookNowPayLater />
          <div className='fields'>
            <div className='mbm'>
              <div id='captcha' />
            </div>
            <div className='btn-wrap'>
              <button type='submit' className='btn-red'>
                {orderEdit ? (
                  <FormattedMessage
                    id='create_option'
                    defaultMessage='Update order'
                  />
                ) : (
                  <FormattedMessage
                    id='request_to_book'
                    defaultMessage='Request to book'
                  />
                )}
              </button>
              <CheckoutBenefits
                freeCancellationDays={selectedTripData.freeCancellationDays}
              />
            </div>
          </div>
        </form>
      )}
    />
  )
}
